require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.function.name");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 4);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, n) {
  e.exports = n(2)();
}, function (e, t, n) {
  "use strict";

  var r = n(3);

  function o() {}

  e.exports = function () {
    function e(e, t, n, o, i, u) {
      if (u !== r) {
        var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw c.name = "Invariant Violation", c;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var n = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t
    };
    return n.checkPropTypes = o, n.PropTypes = n, n;
  };
}, function (e, t, n) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = n(0),
      o = n.n(r);
  n(1);

  function i(e) {
    return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function u() {
    return (u = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function c(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function f(e, t) {
    return !t || "object" !== i(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function l(e) {
    return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function a(e, t) {
    return (a = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var p = o.a.createContext({
    addScrollRef: function addScrollRef() {},
    scrollTo: function scrollTo() {},
    closestElement: ""
  }),
      s = function s(e) {
    var t, n;
    return n = t = function (t) {
      function n() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, n), f(this, l(n).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && a(e, t);
      }(n, o.a.Component), function (e, t, n) {
        t && c(e.prototype, t), n && c(e, n);
      }(n, [{
        key: "render",
        value: function value() {
          var t = this;
          return o.a.createElement(p.Consumer, null, function (n) {
            return o.a.createElement(e, u({}, t.props, {
              active: n.closestElement == t.props.target ? "active" : void 0
            }));
          });
        }
      }]), n;
    }(), function (e, t, n) {
      t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n;
    }(t, "contextType", p), n;
  };

  function y(e) {
    return (y = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function b(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function d(e) {
    return (d = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function h(e, t) {
    return (h = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function m(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function v(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var O = function (e) {
    function t() {
      var e;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), v(m(m(e = function (e, t) {
        return !t || "object" !== y(t) && "function" != typeof t ? m(e) : t;
      }(this, d(t).call(this)))), "toggleClosestElement", function (t) {
        e.state.closestElement != t && e.setState(function (n) {
          return function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {},
                  r = Object.keys(n);
              "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
                return Object.getOwnPropertyDescriptor(n, e).enumerable;
              }))), r.forEach(function (t) {
                v(e, t, n[t]);
              });
            }

            return e;
          }({}, e.state, {
            closestElement: t
          });
        });
      }), v(m(m(e)), "handleScroll", function () {
        if ("undefined" !== e.refRepo) {
          var t = [],
              n = "";
          e.refRepo.map(function (e) {
            if (e.ref) {
              var n = e.ref.getBoundingClientRect(),
                  r = n.top,
                  o = n.bottom;
              r < window.innerHeight && o >= 0 && t.push({
                id: e.id,
                top: r
              });
            }
          }), t.length > 0 && (n = t.reduce(function (e, t) {
            return e.top < t.top ? e : t;
          }), t.reduce(function (e, t) {
            return Math.abs(t.top - window.innerHeight / 2) < Math.abs(e.top - window.innerHeight / 2) ? t : e;
          }), e.toggleClosestElement(n.id));
        }
      }), v(m(m(e)), "addScrollRef", function (t, n) {
        e.refRepo || (e.refRepo = []), n && !e.refRepo.some(function (e) {
          return e.id === t;
        }) && e.refRepo.push({
          id: t,
          ref: n
        });
      }), v(m(m(e)), "scrollTo", function (t) {
        var n = e.refRepo.find(function (e) {
          return e.id === t;
        });
        n && n.ref.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }), e.state = {
        addScrollRef: e.addScrollRef,
        scrollTo: e.scrollTo,
        closestElement: ""
      }, e;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && h(e, t);
    }(t, r["Component"]), function (e, t, n) {
      t && b(e.prototype, t), n && b(e, n);
    }(t, [{
      key: "componentDidMount",
      value: function value() {
        "undefined" != typeof window && window.addEventListener("scroll", this.handleScroll);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        "undefined" != typeof window && window.removeEventListener("scroll", this.handleScroll);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props.children;
        return o.a.createElement(p.Provider, {
          value: this.state
        }, r.Children.only(e));
      }
    }]), t;
  }();

  function w(e) {
    return (w = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function g() {
    return (g = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function j(e, t) {
    if (null == e) return {};

    var n,
        r,
        o = function (e, t) {
      if (null == e) return {};
      var n,
          r,
          o = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      }

      return o;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
      }
    }

    return o;
  }

  function S(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function P(e) {
    return (P = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function _(e, t) {
    return (_ = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function E(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  var T = function (e) {
    function t() {
      var e, n;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++) {
        o[i] = arguments[i];
      }

      return function (e, t, n) {
        t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n;
      }(E(E(n = function (e, t) {
        return !t || "object" !== w(t) && "function" != typeof t ? E(e) : t;
      }(this, (e = P(t)).call.apply(e, [this].concat(o))))), "handleClick", function (e) {
        var t = n.context.scrollTo;
        t && t(e);
      }), n;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && _(e, t);
    }(t, o.a.Component), function (e, t, n) {
      t && S(e.prototype, t), n && S(e, n);
    }(t, [{
      key: "render",
      value: function value() {
        var e = this,
            t = this.props,
            n = t.target,
            r = t.children,
            i = t.Parent,
            u = j(t, ["target", "children", "Parent"]);
        return o.a.createElement(i, g({}, u, {
          onClick: function onClick() {
            return e.handleClick(n);
          }
        }), r);
      }
    }]), t;
  }(),
      x = s(T);

  T.contextType = p, n.d(t, "ScrollToProvider", function () {
    return O;
  }), n.d(t, "ScrollToContext", function () {
    return p;
  }), n.d(t, "ScrollToActionElement", function () {
    return x;
  }), n.d(t, "withScrollTo", function () {
    return s;
  });
}]);